import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import GarageReviewDetailLayer from "../../components/garage-reviews/GarageReviewDetailLayer";

const ViewGarageReviewDetailPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb
          routePath="/garage-reviews"
          routeName="Review Moderation"
          title="View Review Moderation"
        />
        <GarageReviewDetailLayer />
      </MasterLayout>
    </>
  );
};

export default ViewGarageReviewDetailPage;
